export enum TRACKING_METHOD_TYPE {
  project44 = 'project_44',
  keepTruckin = 'keep_truckin',
  mobile = 'mobile',
  fmsMobile = 'fms_mobile',
}
